import {InjectionToken} from '@angular/core';

export type GenericSystemStatusLoggerKey = object;

export interface GenericSystemStatusLogRec {
    key: GenericSystemStatusLoggerKey;
    isOk: boolean;
    message: string;
    codes: Array<number | string>;
}

export interface GenericSystemStatusLogger {
    logStreamingStatus(logRec: GenericSystemStatusLogRec): void;
}

export const SYSTEM_STATUS_LOGGER_TOKEN = new InjectionToken<GenericSystemStatusLogger>('SystemStatusLogger');
